import { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { createPaidOrderInvoiceThunk, getInvoicesThunk, getOrderInvoicesThunk } from '../../../../../../redux/thunk/invoice'

const EMPTY_ORDER_INVOICES = { orderId: null, activeInvoice: null, currentInvoice: null, orderInvoiceable: false }

export const useOrderInvoiceAction = (order) => {
	const dispatch = useDispatch()
	const orderId = order?.orderId ?? null
	const currentOrderId = useRef(orderId)
	const [orderInvoices, setOrderInvoices] = useState(EMPTY_ORDER_INVOICES)
	const [creatingOrderId, setCreatingOrderId] = useState(null)
	currentOrderId.current = orderId

	const refetch = useCallback(async () => {
		if (!orderId) return null
		const result = await dispatch(getOrderInvoicesThunk(orderId))
		if (currentOrderId.current === orderId) {
			setOrderInvoices({ orderId, activeInvoice: result?.activeInvoice ?? null, currentInvoice: result?.currentInvoice ?? null, orderInvoiceable: !!result?.orderInvoiceable })
		}
		return result ?? null
	}, [dispatch, orderId])

	useEffect(() => {
		setOrderInvoices(EMPTY_ORDER_INVOICES)
		refetch()
	}, [refetch])

	const createInvoice = useCallback(async (recipient) => {
		setCreatingOrderId(orderId)
		const invoice = await dispatch(createPaidOrderInvoiceThunk(orderId, recipient))
		const orderInvoicesAfterCreation = await refetch()
		if (invoice) {
			await dispatch(getInvoicesThunk(0, 10))
		}
		setCreatingOrderId(creatingId => creatingId === orderId ? null : creatingId)
		return !!invoice || orderInvoicesAfterCreation?.orderInvoiceable === false
	}, [dispatch, orderId, refetch])

	const isCurrentOrder = !!orderId && orderInvoices.orderId === orderId

	return {
		activeInvoice: isCurrentOrder ? orderInvoices.activeInvoice : null,
		currentInvoice: isCurrentOrder ? orderInvoices.currentInvoice : null,
		orderInvoiceable: isCurrentOrder && orderInvoices.orderInvoiceable,
		refetch,
		createInvoice,
		isCreating: !!orderId && creatingOrderId === orderId,
	}
}
